import React from 'react';
import classnames from 'classnames';

import defaultAvatar from 'asset/image/me_avatar_default@2x.png';
import styles from './index.module.scss';

interface IProps {
  src: string
  width?: number
  height?: number
}

const Avatar: React.FunctionComponent<IProps> = ({
  src,
  width = 32,
  height = 32
}) => {
  const cls = classnames(styles.img, {
    [styles.imgBorder]: !!src
  });

  return (<>
  <img
    src={src || defaultAvatar}
    className={cls}
    style={{ width, height }}
  />
  </>);
};

export default Avatar;
